module.exports = __webpack_public_path__ + "static/img/on2.9248ac66.png";